if(!customElements.get('modal-js')){
  class ModalJs extends HTMLElement {
      constructor() {
          super();

          this.modal = this.querySelector('.modal__wrapper');
          this.opener = this.querySelector('.modal__opener');
          this.closers = this.querySelectorAll('.modal__closer, .modal__overlay');
      }

      connectedCallback() {
          this.setOpener();
          this.setClosers();

      }

      setOpener(){
          this.opener.addEventListener('click', this.openModal.bind(this));
      }

      setClosers() {
          this.closers.forEach(closer => {
              closer.addEventListener('click', this.closeModal.bind(this));
          });
      }
              
      openModal(){
          this.modal.classList.add('modal--open');
      }

      closeModal() {
          this.modal.classList.remove('modal--open');
      }
  }

  customElements.define('modal-js', ModalJs);
}

window.addEventListener('DOMContentLoaded', () => {

  gsap.registerPlugin(Flip);
  
  const allBtns = Array.from(document.querySelectorAll('.swatch__input'));
  const allImgs = Array.from(document.querySelectorAll('.product-single__media-thumb > a'));
  const productTitle = document.querySelector('h1.product-title');
  const productTitleText = productTitle.innerText.toLowerCase();
  
  if(productTitleText.includes('"')){
      const newTitle = productTitle.innerText.replaceAll('"',"'")
      productTitle.innerText = newTitle;
  }
  
  // refresh
  const firstVariant = document.querySelector('.product-image:nth-child(1)');
  const imageIndex = allImgs.findIndex(image => image.dataset.thumbnailId === firstVariant.dataset.mediaId);
  const firstColor = allImgs[imageIndex].title;
  // setCurrentVariant(firstColor);
  
  const activeFlipContainer = document.querySelector('.active-flip');
  const labelValueColor = document.querySelector('.variant-label__value');
  let activeBtn;
  allBtns.forEach(btn => {
      if(firstColor.toLowerCase().includes(btn.value.toLowerCase())){
          activeBtn = btn;
      }
  })

  if(activeBtn){
    labelValueColor.innerText = activeBtn.value;
    const activeBtnParent = activeBtn.parentNode;
    FlipOptionColor(activeBtnParent, activeFlipContainer, true);
  }
  
  function FlipOptionColor(elt, newParent, first){
      const stateLabel = Flip.getState(elt);
  
      if(first){
          elt.parentNode.classList.add('delete-parent');
      }
  
      newParent.appendChild(elt);
  
      Flip.from(stateLabel, {
          duration:0.8,
          scale:true,
          toggleClass:"z-flip",
          onComplete:() => {
              document.querySelector('.delete-parent').style.display = "none";
          }
       });
  }
  
  allBtns.forEach(btn => {
  
      // ébauches filtre
      // if(btn.value.toLowerCase().includes('ébauche') || btn.value.toLowerCase().includes('ebauche')){
      //     btn.parentNode.parentNode.style.display = 'none';
      // }
  
      btn.addEventListener('click', (e) => {
          const color = e.target.value.toLowerCase();
          const btnParent = btn.parentNode;
          const activeBtn = document.querySelector('.active-flip > div');
  
          // setCurrentVariant(color);
  
          FlipOptionColor(activeBtn, btnParent.parentNode);
          FlipOptionColor(btnParent, activeFlipContainer); 
      })
  })
  
  function setCurrentVariant(color){
      for(const link of allImgs){
          const linkTitle = link.title.toLowerCase();
          if(linkTitle != color && linkTitle != productTitleText){
              link.closest('.product-single__media-thumb').style.display = "none";
          } else{
              link.closest('.product-single__media-thumb').style.display = "block";
          }
      }
  }
  
  // toggle description
  
  const allToggleDescriptionButtons = document.querySelectorAll('.svg-toggle');
  
  allToggleDescriptionButtons.forEach(btn => {
      btn.addEventListener('click', () => {
          btn.closest('.description-bloc').classList.toggle('active');
      })
  })
  
  // zoom effect
  
  
  const sliderImagesWrapper = document.querySelector('.productImgSlider');
  const zoomBtn = document.querySelector('.zoom-image-trigger');
  const allImgSlides = document.querySelectorAll('.product-single__media');
  
  let zoomActive = false;
  
  zoomBtn.addEventListener('click', () => {
    if(zoomActive){
      zoomActive = false;
    } else{
      zoomActive = true;
    }
  
    handleZoomEffect();
  })
  
  document.addEventListener('click', (e) => {
    if(!e.target.closest('.zoom-image-trigger') && zoomActive){
      zoomActive = false;
      handleZoomEffect();
    }
  })
  
  document.addEventListener('touchmove', (e) => {
    if(e.target.classList.contains('productImgSlider') && zoomActive){
      zoomMobile(e);
    }
  })
  
  function handleZoomEffect(){
    const activeSlide = document.querySelector('.product-image.is-selected');
    const activeImage = activeSlide.querySelector('.product-single__media');
    
    if(zoomActive){
      activeImage.classList.add('is-zoom');
  
      if(detectDeviceType() == 'touch'){
        activeSlide.closest('.js-productImgSlider').style.pointerEvents = "none";
        disableScroll();
      }
    }
    else{
      allImgSlides.forEach(img => {
        img.classList.remove('is-zoom');
      })
  
      if(detectDeviceType() == 'touch'){
        activeSlide.closest('.js-productImgSlider').style.pointerEvents = "unset";
        enableScroll();
      }
    }
  }
  
  if(detectDeviceType() == 'mouse'){
    allImgSlides.forEach(slide => {
      slide.addEventListener('mousemove', e => {
        zoomActive = true;
        handleZoomEffect();
        zoom(e);
      })
    })
    
    allImgSlides.forEach(slide => {
      slide.addEventListener('mouseleave', e => {
        zoomActive = false;
        handleZoomEffect();
        
        resetZoom(e);
      })
    })
  }
  
  function resetZoom(e) {
      const zoomer = e.currentTarget;
    
      zoomer.style.backgroundPosition = "50% 50%";
      zoomer.style.backgroundSize = "contain";
  }
  
  function zoom(e) {
      const zoomer = e.currentTarget;
      zoomer.style.backgroundSize = "unset";
  
      let offsetX, offsetY;
      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
      e.offsetY ? offsetY = e.offsetY : offsetY = e.touches[0].pageY
      x = (offsetX / zoomer.offsetWidth) * 100
      y = (offsetY / zoomer.offsetHeight) * 100
  
      zoomer.style.backgroundPosition = x + "% " + y + "%";
  }
  
  function zoomMobile(e){
      const zoomer = e.target.querySelector('.product-image.is-selected .product-single__media');
      let offsetX, offsetY;
      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
      e.offsetY ? offsetY = e.offsetY : offsetY = e.touches[0].pageY - 125;
      x = (offsetX / e.target.offsetWidth) * 100;
      y = (offsetY / e.target.offsetHeight) * 100;
    
      if(x > 100 || y > 100 || x < 0 || y < 0) return;
  
      zoomer.style.backgroundPosition = x + "% " + y + "%";
  }
  
  
  function detectDeviceType() {
      if ('ontouchstart' in window || navigator.maxTouchPoints) {
          return 'touch';
      } else {
          return 'mouse';
      }
  }
  
  function disableScroll(){
    document.body.style.height = '100vh';
    document.body.style.overflow = 'hidden';
  }
  function enableScroll(){
    document.body.style.height = 'auto';
    document.body.style.overflow = 'auto';
  }
})

